import { render, staticRenderFns } from "./TributePhotos.vue?vue&type=template&id=560be70c&scoped=true"
import script from "./TributePhotos.vue?vue&type=script&lang=js"
export * from "./TributePhotos.vue?vue&type=script&lang=js"
import style0 from "./TributePhotos.vue?vue&type=style&index=0&id=560be70c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560be70c",
  null
  
)

export default component.exports